import { render, staticRenderFns } from "./RfxSetupLaunch.vue?vue&type=template&id=c5b82b28"
import script from "./RfxSetupLaunch.vue?vue&type=script&lang=js"
export * from "./RfxSetupLaunch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports